var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B01BB0AB-B916-46C2-9251-F1CFD860A5E1@3.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enhancement---Temporary-Limit-Excess",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-5_Temporary-Limit-Excess_Sub-Limit-Popup",
    transform: "translate(-666.000000, -254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up",
    transform: "translate(443.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-alarm_off",
    transform: "translate(220.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333333,11.6666667 L21.6666667,11.6666667 L21.6666667,15 L18.3333333,15 L18.3333333,11.6666667 Z M18.3333333,18.3333333 L21.6666667,18.3333333 L21.6666667,28.3333333 L18.3333333,28.3333333 L18.3333333,18.3333333 Z M20,3.33333333 C10.8,3.33333333 3.33333333,10.8 3.33333333,20 C3.33333333,29.2 10.8,36.6666667 20,36.6666667 C29.2,36.6666667 36.6666667,29.2 36.6666667,20 C36.6666667,10.8 29.2,3.33333333 20,3.33333333 Z M20,33.3333333 C12.65,33.3333333 6.66666667,27.35 6.66666667,20 C6.66666667,12.65 12.65,6.66666667 20,6.66666667 C27.35,6.66666667 33.3333333,12.65 33.3333333,20 C33.3333333,27.35 27.35,33.3333333 20,33.3333333 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#4A5052"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedInfo);
export default __webpack_public_path__ + "static/media/OutlinedInfo.080af8b57e797b7362d13ec16f93d23e.svg";
export { ForwardRef as ReactComponent };